module.exports = __webpack_public_path__ + "media/images/emblems/La_Baroche-coat_of_arms-4b662ed70b82dcd3553b30d82461c87a.svg";